import {ClientUserReportModel} from '@spa/api';

import {
    ReportTableData,
    ReportTableColumn,
    ReportTableConfigInterface,
    ReportTableActionMenuTypesEnum
} from '../../../app/shared/components/report-table';


export const PanelClientsEditUsersDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: ClientUserReportModel.getStatusSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<number>({
            colId: ClientUserReportModel.getNameSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ClientUserReportModel.getEmailSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ClientUserReportModel.getPhoneNumberSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ClientUserReportModel.getIsLegalRepresentativeSelector(),
            value: null,
            hidden: false
        })
    ];
};

export const PanelClientsEditUsersDataTableConfig = (): ReportTableConfigInterface => {
    return {
        rows: [],
        columns: [
            new ReportTableColumn({
                label: 'Status',
                selector: ClientUserReportModel.getStatusSelector()
            }),
            new ReportTableColumn({
                label: 'Name',
                selector: ClientUserReportModel.getNameSelector()
            }),
            new ReportTableColumn({
                label: 'Email',
                selector: ClientUserReportModel.getEmailSelector()
            }),
            new ReportTableColumn({
                label: 'Phone',
                selector: ClientUserReportModel.getPhoneNumberSelector()
            }),
            new ReportTableColumn({
                label: 'Type',
                selector: ClientUserReportModel.getIsLegalRepresentativeSelector()
            }),

        ],
        hiddenColumnIds: [],
        actionMenu: false,
        actionMenuType: ReportTableActionMenuTypesEnum.Buttons,
        actionMenuItems: []
    };
};
